/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PurchaseProbabilityEnum;

(function (PurchaseProbabilityEnum) {
  PurchaseProbabilityEnum["NOT_INTERESTED"] = "not_interested";
  PurchaseProbabilityEnum["LOW"] = "low";
  PurchaseProbabilityEnum["MEDIUM"] = "medium";
  PurchaseProbabilityEnum["HIGH"] = "high";
})(PurchaseProbabilityEnum || (PurchaseProbabilityEnum = {}));